import { baseURLs } from '@/data/baseURL'
/* eslint-disable */
import { appendAppLocaleQuery } from '@/i18n/cross-app-query'

const parseCookieObj = () => {
  const cookieObj = {}
  if (!document.cookie) return cookieObj
  document.cookie.split('; ').forEach(item => {
    if (!item) return
    const [key, value] = item.split('=')
    if (key === 'userInfo') {
      try {
        cookieObj[key] = JSON.parse(decodeURIComponent(value))
      } catch (e) {
        cookieObj[key] = null
      }
    } else {
      cookieObj[key] = value
    }
  })
  return cookieObj
}

const writeUserInfoCookie = (userInfo, domain, exp) => {
  document.cookie = `userInfo=${encodeURIComponent(JSON.stringify(userInfo))}; domain=${domain}; expires=${exp.toGMTString()}`
}

const hasRealLoginAccount = userInfo =>
  !!(userInfo && userInfo.loginAccount && userInfo.loginAccount !== '免登模式')

export const getCookie = () => {
  const domain = getDomain()
  let exp = new Date()
  exp.setTime(exp.getTime() + 30 * 24 * 60 * 60 * 1000); // 过期时间一个月

  const searchObj = getLocationSearch()
  // 先读已有 cookie：visa-web-new 正常登录也会带 sessionId 跳转，不能误当成免登覆盖
  const cookieObj = parseCookieObj()

  if (searchObj.sessionId) {
    if (hasRealLoginAccount(cookieObj.userInfo)) {
      // 正常登录跳转：保留账号信息，同步 URL 中的 sessionId（供接口鉴权）
      const userInfo = {
        ...cookieObj.userInfo,
        sessionId: searchObj.sessionId,
      }
      writeUserInfoCookie(userInfo, domain, exp)
      cookieObj.userInfo = userInfo
    } else if (cookieObj.userInfo && cookieObj.userInfo.loginAccount === '免登模式') {
      // 已是免登身份：只更新 sessionId
      const userInfo = {
        ...cookieObj.userInfo,
        sessionId: searchObj.sessionId,
      }
      writeUserInfoCookie(userInfo, domain, exp)
      cookieObj.userInfo = userInfo
    } else {
      // 无真实登录 cookie：按免登写入，保证接口能带上 sessionId
      const userInfo = {
        sessionId: searchObj.sessionId,
        loginAccount: '免登模式',
        bizRole: 'A', // 免登模式默认使用最大权限
        visaAuth: 1,
        feizhuAuth: 1,
        orderAuth: 1,
      }
      writeUserInfoCookie(userInfo, domain, exp)
      cookieObj.userInfo = userInfo
    }
  } else if (searchObj.safari) { // 兼容safari浏览器，用户的数据通过URL传入
    const [
      sessionId,
      operatorId,
      mobile,
      loginAccount,
      bizRole,
      visaAuth,
      orderAuth,
      feizhuAuth,
      insuranceAuth,
      applyVisaAuth,
      ticketAuth,
      isOpenSupplier,
      companyName,
      companyId,
      nick,
      source,
      scorePriceStatus,
      channel
    ] = searchObj.safari.split('_') // 解析userInfo的数据
    const userInfo = {
      sessionId,
      operatorId,
      mobile,
      loginAccount,
      bizRole,
      visaAuth: Number(visaAuth),
      orderAuth: Number(orderAuth),
      feizhuAuth: Number(feizhuAuth),
      insuranceAuth: Number(insuranceAuth),
      applyVisaAuth: Number(applyVisaAuth),
      ticketAuth: Number(ticketAuth),
      isOpenSupplier,
      companyName,
      companyId,
      nick,
      source,
      scorePriceStatus,
      channel
    }
    writeUserInfoCookie(userInfo, domain, exp)
    cookieObj.userInfo = userInfo
  }
  return cookieObj
}

/** 非免登落地时去掉 URL 中的 sessionId，避免地址栏显示并再次被当成免登 */
export const cleanNonFreeLoginSessionIdInUrl = () => {
  const searchObj = getLocationSearch()
  if (!searchObj.sessionId) return
  if (!hasRealLoginAccount(parseCookieObj().userInfo)) return

  const match = window.location.href.match(/^(.*)\?([^#]*)(#.*)?$/)
  if (!match) return
  const [, originPath, query, hash = ''] = match
  const nextQuery = query
    .split('&')
    .filter(item => item && !item.startsWith('sessionId='))
    .join('&')
  const next = nextQuery ? `${originPath}?${nextQuery}${hash}` : `${originPath}${hash}`
  if (next !== window.location.href) {
    window.history.replaceState(null, '', next)
  }
}

export const getLocationSearch = () => {
  const searchObj = {}
  const searchMath = window.location.href.match(/\?(.+)#\//)
  if (searchMath) {
    const searchStr = searchMath[1]
    if (searchStr) {
      searchStr.split('&').forEach(item => {
        if (item) {
          const [key, value] = item.split('=')
          searchObj[key] = value
        }
      })
    }
  }
  return searchObj
}

export const getPageURL = type => {
  const searchObj = getLocationSearch();
  let baseURL = ''
  const { hostname } = location
  if (hostname === 'localhost') { // 本地环境
    switch (type) {
      case 'wangdan':
        baseURL = 'http://localhost:8088'
        break
      case 'platform':
        baseURL = 'http://localhost:8090'
        break
      case 'mall':
        baseURL = 'http://localhost:8091'
        break
      case 'mallDetails':
        baseURL = 'http://localhost:8091'
        break
      case 'online':
        baseURL = 'http://localhost:8093'
        break
      case 'ticket':
        baseURL = 'http://localhost:8092'
        break
      case 'visa':
        baseURL = 'http://localhost:8087'
        break
      case 'shanfu':
        baseURL = 'http://localhost:3301'
        break
    }
  } else {
    const domain = getDomain()
    console.log(domain, 'domain')
    switch (type) {
      case 'wangdan':
        baseURL = (domain === 'visaai.com' ? 'https://order-management.' : 'http://h5-visas-order-management.') + domain
        break
      case 'platform':
        if (domain == 'bx-pre.dlbxjj.com') {
          baseURL = 'http://h5-visas-platform.qa.visaapp6.com'
        } else if (domain == 'dlbxjj.com') {
          baseURL = 'https://platform.visaai.com'
        }else if(domain == 'meditrustbroker.com'){
          baseURL = 'https://platform.visaai.com'
        }
        else {
          baseURL = (domain === 'visaai.com' ? 'https://platform.' : 'http://h5-visas-platform.') + domain
        }
        // baseURL = (domain === 'visaai.com' ? 'https://platform.' : 'http://h5-visas-platform.') + domain
        break
      case 'mall':
        if (domain == 'bx-pre.dlbxjj.com') {
          baseURL = 'http://h5-visas-mall.qa.visaapp6.com'
        } else if (domain == 'dlbxjj.com') {
          baseURL = 'https://mall.visaai.com'
        }else if (domain == 'meditrustbroker.com') {
          baseURL = 'https://mall.visaai.com'
        }
         else {
          baseURL = ((domain === 'visaai.com') ? 'https://mall.' : 'http://h5-visas-mall.') + domain
        }
        break
      case 'mallDetails':
        baseURL = (searchObj.mode == 'newTest' ? 'http://h5-visas-mall.qa.visaapp6.com' : 'https://mall.visaai.com')
        break
      case 'ticket':
        baseURL = (domain === 'visaai.com' ? 'https://plane-ticket.' : ' http://h5-visas-plane-ticket.') + domain
        break
      case 'visa':
        if (domain == 'bx-pre.dlbxjj.com') {
          baseURL = 'http://h5-visas-web.qa.visaapp6.com'
        } else if (domain == 'dlbxjj.com') {
          baseURL = 'https://b.visaai.com'
        }else if (domain == 'meditrustbroker.com') {
          baseURL = 'https://b.visaai.com'
        }
         else {
          baseURL = (domain === 'visaai.com' ? 'https://b.' : ' http://h5-visas-web.') + domain
        }

        break
      case 'visa':
        baseURL = (domain === 'visaai.com' ? 'https://b.' : ' http://h5-visas-web.') + domain
        break

      case 'online':
        baseURL = (domain === 'visaai.com' ? 'https://onlinereceipt.' : ' http://h5-visas-receipt-web.') + domain
        break
    }
    // switch (type) {
    // 	case 'wangdan':
    // 	  baseURL = (domain === 'thunderrpa.cn' ? 'https://order-management.' : 'http://h5-visas-order-management.') + domain
    // 	  break
    // 	case 'platform':
    // 	  baseURL = (domain === 'thunderrpa.cn' ? 'https://platform.' : 'http://h5-visas-platform.') + domain
    // 	  break
    // 	case 'mall':  
    // 	  baseURL = (domain === 'thunderrpa.cn' ? 'https://mall.' : ' http://h5-visas-mall.') + domain
    // 	  break
    // 	case 'ticket':
    // 	  // TODO
    // 	  baseURL = (domain === 'thunderrpa.cn' ? 'https://' : ' http://') + domain
    // 	  break
    // 	case 'visa':
    // 	  baseURL = (domain === 'thunderrpa.cn' ? 'https://b.' : ' http://h5-visas-web.') + domain
    // 	  break
    //   }
  }
  return baseURL + '/'
}

export const getWebURL = type => {
  const { search } = location
  const searchObj = getLocationSearch()
  let searchStr = search
  console.log(searchObj.userInfo,'searchObj.userInfo')
  if (searchObj.userInfo) {
    if(type != 'mallDetails'){
      searchStr = ``
    }
   
  }
  else if (searchObj.sessionId) { // 免登模式
    if (searchObj.mode) {
      searchStr = `?mode=${searchObj.mode}&sessionId=${searchObj.sessionId}`
    } else {
      searchStr = `?sessionId=${searchObj.sessionId}`
    }
  } else if (searchObj.safari) { // 兼容safari浏览器
    if (type === 'visa') { // 闪电签不需要兼容safari浏览器
      if (searchObj.mode) {
        searchStr = `?mode=${searchObj.mode}`
      } else {
        searchStr = ''
      }
    } else {
      if (searchObj.mode) {
        searchStr = `?mode=${searchObj.mode}&safari=${searchObj.safari}`
      } else {
        searchStr = `?safari=${searchObj.safari}`
      }
    }
  }
  searchStr = appendAppLocaleQuery(searchStr)
  return getPageURL(type) + searchStr + '#'
}

export const getDomain = () => {
  const { hostname } = location
  let domain = ''
  if (hostname === 'localhost') {
    domain = 'localhost'
  } else {
    const dotIndex = hostname.indexOf('.')
    domain = hostname.slice(dotIndex + 1)
  }
  return domain
}

export const getBaseURL = (type, isFile) => {
  // const list = baseURLs[type]
  // let { mode } = getLocationSearch()
  // mode = mode || 'prod'
  // const serviceType = isFile && (mode === 'test' || mode === 'prod') ? mode + '-file' : mode
  // const baseURL = list[serviceType]
  // return baseURL
  if(process.env.NODE_ENV !='development'){
    const list = baseURLs[type]
    let { mode } = getLocationSearch()
    mode = 'prod'
    const serviceType = isFile && (mode === 'test' || mode === 'prod') ? mode + '-file' : mode
    const baseURL = list[serviceType]
    return baseURL
  }else{
    const list = baseURLs[type]
    let { mode } = getLocationSearch()
    mode = mode || 'newTest'
    const serviceType = isFile && (mode === 'test' || mode === 'prod') ? mode + '-file' : mode
    const baseURL = list[serviceType]
    return baseURL
  }
}
